export default __webpack_public_path__ + "static/media/15-2.514ac2b2.jpg";